module.exports = __webpack_public_path__ + "circle_4px.0f56347f1dd57e39cb8c687849949453.svg";